import { colors } from "@/utils/colors";
import { Wave } from "../Wave";

export const NavToggle = ({
  onClick,
  className,
}: {
  className?: string;
  onClick: () => void;
}) => {
  return (
    <button
      className={`nav-toggle flex flex-col bg-tertiary px-2 pt-2 pb-[0.7rem] gap-1 rounded-xl transition-all hover:bg-secondary duration-[0.2s]${
        className ? ` ${className}` : ""
      }`}
      onClick={onClick}
    >
      {Array.from({ length: 3 }).map((_, i) => (
        <Wave
          key={i}
          color={colors.primaryDark}
          thickness={18}
          width={355}
          className="h-[5px] w-[30px]"
        />
      ))}
    </button>
  );
};
